import Auth from '@/models/Auth';

const itemHasPermission = item => {
    if (!('permissions' in item)) {
        return true;
    }

    const can = Auth().can;

    return item.permissions.every(permission => can(permission));
};

export default itemHasPermission;
